import { combineReducers } from "redux";
import site from './site';
const root = combineReducers({
    site,
});

export default root;